import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';
import { CountPolicy } from '../policy';
import { QuantityResult } from '../types';

export class RatioUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Percentage'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: RatioUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): RatioUnitConverter {
    if (!RatioUnitConverter.instance) {
      RatioUnitConverter.instance = new RatioUnitConverter();
    }
    return RatioUnitConverter.instance;
  }

  protected units = ['percent nano (n%)', 'percent (%)', 'apdex', 'fraction'] as const;

  protected unitToBase = {
    'percent nano (n%)': 1e-9,
    'percent (%)': 1,
    apdex: 100,
    fraction: 100,
  };

  override convertToBestUnit(
    value: number,
    fromUnit: string,
    countPolicy?: CountPolicy,
  ): QuantityResult {
    const policy = this.resolveCountPolicy(countPolicy);

    if (!this.isValidUnit(fromUnit)) {
      return policy(value, fromUnit);
    }

    if (value === 0) {
      return policy(value, fromUnit);
    }

    // percent(%) → percent nano(n%) 전환 규칙
    if (fromUnit === 'percent (%)') {
      const THRESHOLD = 1e-6; // 0.000001%
      const abs = Math.abs(value);

      if (abs < THRESHOLD) {
        // n% 값 = % 값을 1e9 배 (부호 유지)
        const nanoPercentValue = value * 1e9;
        return policy(nanoPercentValue, 'percent nano (n%)');
      }

      // 그 외는 % 유지
      return policy(value, 'percent (%)');
    }

    // 나머지 단위(fraction, apdex, n% 등)는 그대로
    return policy(value, fromUnit);
  }

  override convertToLargerBestUnit(
    value: number,
    fromUnit: string,
    countPolicy?: CountPolicy,
  ): QuantityResult {
    const policy = this.resolveCountPolicy(countPolicy);

    return policy(value, fromUnit);
  }
}
